import * as React from 'react';
import cn from 'classnames';

type SpinnerSize = 'xxs' | 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'xxl';

export type SpinnerProps = React.SVGAttributes<SVGElement> & {
	size?: SpinnerSize;
	ariaLabel: string;
};

const sizes = {
	xxs: 12,
	xs: 20,
	sm: 28,
	base: 36,
	lg: 44,
	xl: 52,
	xxl: 60,
};

const Spinner = ({
	size = 'base',
	className = '',
	ariaLabel,
	...rest
}: SpinnerProps): React.ReactElement => (
	<svg
		className={cn(`rounded-full animate-spin`, className || 'fill-white')}
		role="progressbar"
		aria-busy="true"
		aria-live="polite"
		aria-label={ariaLabel}
		tabIndex={-1}
		viewBox="24 24 48 48"
		width={sizes[size] || 'base'}
		height={sizes[size] || 'base'}
		{...rest}
	>
		<circle
			className="animate-dash"
			cx="48"
			cy="48"
			r="20"
			fill="none"
			strokeWidth="6"
			strokeMiterlimit="10"
			strokeLinecap="round"
		/>
	</svg>
);

export default Spinner;
